import { c as _c } from "react/compiler-runtime";
import { ActionMenu, ActionMenuItem, FormInput, Hint } from '@systemeio/ui';
import { removeCourseBundleItem, updateCourseBundleItem } from 'modules/courses/bundles/course-bundle/api/course-bundle-api';
import { useCoursesList } from 'modules/courses/bundles/course-bundle/hooks/use-courses-list';
import { CourseBundleInterface, CourseBundleItemInterface } from 'modules/courses/bundles/course-bundle/types/course-bundle-interface';
import { getSortedCourseList } from 'modules/courses/bundles/course-bundle/utils/get-sorted-course-list';
import { nonDraggableProps } from 'modules/courses/courses/curriculum/utils/non-draggable-props';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import Confirmation from 'shared/components/confirmation-modal';
import EditModal from 'shared/components/edit-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { fetchWithFieldErrors } from 'shared/utils/fetch-with-errors';
import { KeyedMutator } from 'swr';
interface CourseActionsProps {
  item: CourseBundleItemInterface;
  mutate: KeyedMutator<CourseBundleInterface>;
}
const defaultErrors = {
  fields: {
    delayBeforeStart: ''
  }
};
function CourseActions(t0) {
  const $ = _c(75);
  const {
    item,
    mutate
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const router = useRouter();
  const {
    courseBundleId
  } = router.query;
  const {
    mutate: mutateCoursesList
  } = useCoursesList(courseBundleId as string);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  const [settingErrors, setSettingErrors] = useState(defaultErrors);
  let T0;
  let onRemoveCourseBundleItem;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== isSettingsOpen || $[1] !== item || $[2] !== mutate || $[3] !== mutateCoursesList || $[4] !== settingErrors || $[5] !== t) {
    const caption = t("dashboard.course_bundle.course.title");
    let t8;
    if ($[15] !== item.course || $[16] !== mutate || $[17] !== mutateCoursesList) {
      t8 = async itemId => {
        await removeCourseBundleItem(itemId);
        await mutate(data => {
          if (data) {
            return {
              ...data,
              items: data.items.filter(item_0 => item_0.id !== itemId)
            };
          }
        }, false);
        await mutateCoursesList(data_0 => {
          if (data_0) {
            return getSortedCourseList([...data_0, item.course]);
          }
        }, false);
      };
      $[15] = item.course;
      $[16] = mutate;
      $[17] = mutateCoursesList;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    onRemoveCourseBundleItem = t8;
    let t9;
    if ($[19] !== mutate) {
      t9 = async (itemId_0, delayBeforeStart) => {
        await fetchWithFieldErrors(async () => {
          await updateCourseBundleItem(delayBeforeStart, itemId_0);
          await mutate(data_1 => {
            if (data_1) {
              return {
                ...data_1,
                items: data_1.items.map(item_1 => {
                  if (item_1.id === itemId_0) {
                    return {
                      ...item_1,
                      ...delayBeforeStart
                    };
                  }
                  return item_1;
                })
              };
            }
          }, false);
        }, setSettingErrors);
      };
      $[19] = mutate;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    const onEditCourse = t9;
    t7 = "flex items-center lg:justify-end";
    t4 = nonDraggableProps;
    let t10;
    if ($[21] !== t) {
      t10 = t("dashboard.actions.title.settings");
      $[21] = t;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    let t11;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = () => {
        setIsSettingsOpen(true);
      };
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    let t12;
    if ($[24] !== t10) {
      t12 = <ActionMenuItem key="settings" label={t10} onClick={t11} />;
      $[24] = t10;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    let t13;
    if ($[26] !== t) {
      t13 = t("dashboard.actions.title.remove");
      $[26] = t;
      $[27] = t13;
    } else {
      t13 = $[27];
    }
    let t14;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = () => {
        setIsRemoveOpen(true);
      };
      $[28] = t14;
    } else {
      t14 = $[28];
    }
    let t15;
    if ($[29] !== t13) {
      t15 = <ActionMenuItem key="remove" label={t13} onClick={t14} />;
      $[29] = t13;
      $[30] = t15;
    } else {
      t15 = $[30];
    }
    if ($[31] !== t12 || $[32] !== t15) {
      t5 = <ActionMenu menuItems={[t12, t15]} />;
      $[31] = t12;
      $[32] = t15;
      $[33] = t5;
    } else {
      t5 = $[33];
    }
    let t16;
    if ($[34] !== t) {
      t16 = t("dashboard.course_bundle.course.edit_delay_title");
      $[34] = t;
      $[35] = t16;
    } else {
      t16 = $[35];
    }
    let t17;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = () => {
        setIsSettingsOpen(false);
      };
      $[36] = t17;
    } else {
      t17 = $[36];
    }
    let t18;
    if ($[37] !== t) {
      t18 = t("global.changes_saved");
      $[37] = t;
      $[38] = t18;
    } else {
      t18 = $[38];
    }
    let t19;
    if ($[39] !== settingErrors || $[40] !== t) {
      t19 = [{
        field: "delayBeforeStart",
        onRender: (value, onChange) => <FormInput key="course-edit" value={value} onChange={e => onChange(Number(e.target.value))} type="number" label={<Hint label={t("dashboard.course_bundle.course.delay_title_tooltip")}>{t("dashboard.course_bundle.course.delay_before_start_title")}</Hint>} error={settingErrors.fields.delayBeforeStart} />
      }];
      $[39] = settingErrors;
      $[40] = t;
      $[41] = t19;
    } else {
      t19 = $[41];
    }
    let t20;
    if ($[42] !== item.id || $[43] !== onEditCourse) {
      t20 = data_2 => onEditCourse(item.id, data_2);
      $[42] = item.id;
      $[43] = onEditCourse;
      $[44] = t20;
    } else {
      t20 = $[44];
    }
    if ($[45] !== isSettingsOpen || $[46] !== item || $[47] !== t16 || $[48] !== t18 || $[49] !== t19 || $[50] !== t20) {
      t6 = <EditModal fullCaption={t16} opened={isSettingsOpen} onClose={t17} instance={item} toastCaption={t18} editable={t19} onEdit={t20} />;
      $[45] = isSettingsOpen;
      $[46] = item;
      $[47] = t16;
      $[48] = t18;
      $[49] = t19;
      $[50] = t20;
      $[51] = t6;
    } else {
      t6 = $[51];
    }
    T0 = Confirmation;
    if ($[52] !== t) {
      t1 = t("dashboard.course_bundle.course.remove_confirmation_title");
      $[52] = t;
      $[53] = t1;
    } else {
      t1 = $[53];
    }
    if ($[54] !== t) {
      t2 = t("dashboard.course_bundle.course.remove_confirmation_text");
      $[54] = t;
      $[55] = t2;
    } else {
      t2 = $[55];
    }
    t3 = t("dashboard.actions.removed", {
      module: caption?.toLowerCase()
    });
    $[0] = isSettingsOpen;
    $[1] = item;
    $[2] = mutate;
    $[3] = mutateCoursesList;
    $[4] = settingErrors;
    $[5] = t;
    $[6] = T0;
    $[7] = onRemoveCourseBundleItem;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    T0 = $[6];
    onRemoveCourseBundleItem = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
  }
  let t8;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsRemoveOpen(false);
    $[56] = t8;
  } else {
    t8 = $[56];
  }
  let t9;
  if ($[57] !== item.id || $[58] !== onRemoveCourseBundleItem) {
    t9 = () => onRemoveCourseBundleItem(item.id);
    $[57] = item.id;
    $[58] = onRemoveCourseBundleItem;
    $[59] = t9;
  } else {
    t9 = $[59];
  }
  let t10;
  if ($[60] !== T0 || $[61] !== isRemoveOpen || $[62] !== t1 || $[63] !== t2 || $[64] !== t3 || $[65] !== t9) {
    t10 = <T0 title={t1} confirmationText={t2} toastCaption={t3} opened={isRemoveOpen} onClose={t8} onConfirm={t9} />;
    $[60] = T0;
    $[61] = isRemoveOpen;
    $[62] = t1;
    $[63] = t2;
    $[64] = t3;
    $[65] = t9;
    $[66] = t10;
  } else {
    t10 = $[66];
  }
  let t11;
  if ($[67] !== t10 || $[68] !== t4 || $[69] !== t5 || $[70] !== t6) {
    t11 = <div {...t4}>{t5}{t6}{t10}</div>;
    $[67] = t10;
    $[68] = t4;
    $[69] = t5;
    $[70] = t6;
    $[71] = t11;
  } else {
    t11 = $[71];
  }
  let t12;
  if ($[72] !== t11 || $[73] !== t7) {
    t12 = <div className={t7}>{t11}</div>;
    $[72] = t11;
    $[73] = t7;
    $[74] = t12;
  } else {
    t12 = $[74];
  }
  return t12;
}
export default CourseActions;